import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Ejemplos from "@/pages/Ejemplos";
import Paquetes from "@/pages/Paquetes";
import Contacto from "@/pages/Contacto";

// Handles hash navigation when navigating from another route to homepage anchors.
const HashAnchorHandler = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait a tick for DOM to render
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HashAnchorHandler />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ejemplos" element={<Ejemplos />} />
            <Route path="/paquetes" element={<Paquetes />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
